export const CREATE_ACCOUNT_AJAX_SUCCESS = "CREATE_ACCOUNT_AJAX_SUCCESS";